import EventRegistryAPI from "../api/EventRegistryAPI";
import DirectoryEvent from '../models/DirectoryEvent';
import IntegrationEvent from '../models/IntegrationEvent';

/* eslint-disable no-param-reassign */
const module = {
  namespaced: true,
  state: {
    commands: [],
    indexOfApplyingEvent: 0,
    selectedAssetComponent: null,
    selectedAssetComponentsLength: null,
    selectedPaymentParam: null,
    selectedAsset: null,
    showModalToformDirectoryEvent: false,
    directoryEvents: [],
    integrationEvents: [],
    integrationEventDate: null,
    integrationEventIdInDb: null,
    integrationEventIdInDbList: [],
  },
  mutations: {

    // Этот метод будет вызывать equal метод каждой команды
    // если найдёт совпдание, то обновит, если нет, то добавит.
    // пример есть в тестовом классе:
    // eventRegistryModule.addOrUpdateCommand.spec.js
    addOrUpdateCommand(state, command) {
      if (command.equal == null) throw new Error(
        "Cannot addOrUpdateCommand because command has no equal method! Please add it.");

      const item = state.commands.find(item => item.equal(command));
      if (item == null)
        state.commands.push(command);
      else
        Object.assign(item, command);
    },

    clearCommands(state) {
      state.commands = [];
    },

    removeCommand(state, command) {
      if (command.equal == null) throw new Error(
        "Cannot addOrUpdateCommand because command has no equal method! Please add it.");
      const item = state.commands.find(item => item.equal(command));
      const index = state.commands.indexOf(item);
      state.commands.splice(index, 1);
    },

    editCardDataEventsCommands(state, data) {
      if(data !== null) {
        state.selectedAssetComponent = data.assetComponent;
        state.selectedAssetComponentsLength = data.assetComponentLength;
      } else {
        state.selectedAssetComponent = null;
        state.selectedAssetComponentsLength = null;
      }
    },

    editAssetComponentCommands(state, data) {
      if(data !== null) {
        state.selectedAssetComponent = data.assetComponent;
        state.selectedAssetComponentsLength = data.assetComponentLength;
      } else {
        state.selectedAssetComponent = null;
        state.selectedAssetComponentsLength = null;
      }
    },
    editAssetCommands(state, asset) {
      state.selectedAsset = asset;
    },
    editPaymentParamsCommands(state, paymentParams) {
      state.selectedPaymentParam = paymentParams;
    },

    toggleModalToFormDirectoryEvent(state, value) {
      state.showModalToformDirectoryEvent = value;
    },

    deleteAllCommands(state) {
      state.commands = [];
    },

    setDirectoryEvents(state, events) {
      state.directoryEvents = events;
    },

    setIntegrationEvents(state, events) {
      state.integrationEvents = events;
    },

    addIntegrationEventDate(state, date) {
      state.integrationEventDate = date;
    },

    addIntegrationEventIdInDb(state, id) {
      state.integrationEventIdInDb = id;
    },

    addIntegrationEventIdInDbToList(state, id) {
      const result = [...state.integrationEventIdInDbList];
      result.push(id);
      state.integrationEventIdInDbList = result;
    },

    clearIntegrationEventList(state) {
      state.integrationEventIdInDbList = [];
      state.integrationEventDate = null
    },

    increaseIndex(state) {
      state.indexOfApplyingEvent++;
    },

    decreaseIndex(state) {
      state.indexOfApplyingEvent--;
    },

    clearIndex(state) {
      state.indexOfApplyingEvent = 0;
    },
  },

  actions: {
    async loadAllDirectoryEventForContract({
                                             commit
                                           }, contractId) {
      const response = await new EventRegistryAPI().getDirectoryEvents(contractId);
      const result = [];
      for (let i = 0; i < response.length; i++) {
        result.push(DirectoryEvent.createFromData(response[i]));
      }
      commit("setDirectoryEvents", result);
      return result;
    },
    async loadAllIntegrationEventForContract({
                                               commit
                                             }, contractId) {
      const response = await new EventRegistryAPI().getIntegrationEvents(contractId);
      const result = [];
      for (let i = 0; i < response.length; i++) {
        result.push(IntegrationEvent.createFromData(response[i]));
      }
      commit("setIntegrationEvents", result);
      return result;
    },
    async removeLastEvent({commit}, eventId) {
      const response = await new EventRegistryAPI().removeLastEvent(eventId);
      return response;
    },
    async rollbackLastEvent({commit}, eventId) {
      const response = await new EventRegistryAPI().rollBackLastEvent(eventId);
      return response;
    },
    async parseManualChartFromExcel({commit}, payload) {
      return await new EventRegistryAPI().parseManualChartFromExcel(payload);
    }
  },

  getters: {
    getDirectoryEvents: state => state.directoryEvents || [],
    getIntegrationEvents: state => state.integrationEvents || [],
    getAssetComponentLength: state => state.selectedAssetComponentsLength ||  null,
    getIndexOfAppliedEvent: state => state.indexOfApplyingEvent,
  },
};

export default module;
